import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import TabbedPage from 'tio-employee/components/landing/tabbed-page';
import type { TabbedPageTab } from 'tio-employee/components/landing/tabbed-page';
import { PhGraduationCap, PhStack } from 'ember-phosphor-icons';
import type IntlService from 'ember-intl/services/intl';

const ROUTE_PREFIX = 'authenticated.questions-you-have.paying-for-college';

export default class PayingForCollegePage extends Component {
  @service declare intl: IntlService;

  get tabs(): TabbedPageTab[] {
    return [
      {
        id: 'federal',
        label: this.intl.t('questions_you_have.types_of_student_loans.federal_aid'),
        route: `${ROUTE_PREFIX}.index`,
      },
      {
        id: 'private',
        label: this.intl.t('questions_you_have.types_of_student_loans.private_loans'),
        route: `${ROUTE_PREFIX}.private-loans`,
      },
      {
        id: 'plus',
        label: this.intl.t('questions_you_have.types_of_student_loans.plus_loans'),
        route: `${ROUTE_PREFIX}.plus-loans`,
      },
    ];
  }

  <template>
    <TabbedPage
      @icon={{PhGraduationCap}}
      @title={{t "questions_you_have.paying_for_college.what_is_federal_loan_q"}}
      @subtitle={{t "questions_you_have.paying_for_college.what_is_federal_loan_a"}}
      @sectionIcon={{PhStack}}
      @sectionTitle={{t "questions_you_have.types_of_student_loans.default"}}
      @tabs={{this.tabs}}
    >
      {{outlet}}
    </TabbedPage>
  </template>
}
